import {
    PAINT_LIST_GET,
    PAINT_LIST_GET_F,
    PAINT_LIST_GET_R,
    PAINT_SELECTED_SET
} from '../actionType'

const initialState = {
    paint: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    selectedPaint: null,
}

export default function paintReducer (state = initialState, action : any)  {
    switch (action.type) {
        case PAINT_LIST_GET:
            return {
            ...state,
            isLoading: true,
            error: null
            }
        case PAINT_LIST_GET_F:
            // console.log('action called')
            // console.log(action.payload.data,'content')
            return {
                ...state,
                isLoading: false,
                paint: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case PAINT_LIST_GET_R:
            
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case PAINT_SELECTED_SET:
            return {
                ...state,
                selectedPaint: action.payload
            }
        default:
            return state
    }
}